// extracted by mini-css-extract-plugin
export default {"controller":"UpAnimatie_controller__bPkoV","bounce-down":"UpAnimatie_bounce-down__2F3yF","img":"UpAnimatie_img__aezUk"};